//sadnand_gadwal

import {
  // Presales Incentive Plan
  GET_PRESALES_INCENTIVE_PLAN,
  GET_PRESALES_INCENTIVE_PLAN_DETAIL,
  GET_PRESALES_INCENTIVE_PLAN_EXPORT,
  GET_ITEM_FOR_PRE_SALES_INCENTIVE,
  //PreSales New
  GET_LEAD,
  GET_LEAD_EXPORT,
  GET_LEAD_SEARCH,
  GET_LEAD_DETAIL,
  GET_USER_FOR_LEAD,
  GET_USER_FOR_SITE_VISIT_HANDLED,
  GET_COUNTRY_CODE_FOR_PRESALES,
  GET_PROJECT_FOR_LEAD,
  GET_SOURCE_CATEGORY_FOR_PRESALES,
  GET_SOURCE_FOR_LEAD,
  GET_CRM_LEAD_STATUS_COUNT,
  GET_LEAD_CALL_CONTACT_NUMBER,
  GET_LEAD_FILTER_PROJECT,
  GET_LEAD_FILTER_SOURCE,
  GET_LEAD_FILTER_STATUS,
  GET_LEAD_FILTER_CATEGORY,
  GET_LEAD_FILTER_ASSIGNED_TO,
  GET_LEAD_FILTER_DEPARTMENT,
  GET_LEAD_FILTER_DATE_TYPE,
  GET_LEAD_OWNER_FILTER_LIST,
  GET_LEAD_SITE_VISIT,
  GET_LEAD_SITE_VISIT_EXPORT,
  GET_LEAD_PROFILE,
  GET_CITY,
  GET_CUSTOMER_CURRENT_LIVING_FOR_PRESALES,
  GET_CUSTOMER_SUITABLE_TIME_FOR_PRESALES,
  GET_CUSTOMER_CONSTRUCTION_PLANNING_FOR_PRESALES,
  GET_CUSTOMER_BUDGET_FOR_PRESALES,
  GET_CRM_DIMENSION_FOR_PRESALES,
  GET_CUSTOMER_INCOME_FOR_PRESALES,
  GET_CUSTOMER_WORK_EXPERIENCE_FOR_PRESALES,
  GET_CUSTOMER_WORK_FUNCTION_FOR_PRESALES,
  GET_CUSTOMER_WORK_SECTOR_FOR_PRESALES,
  GET_CUSTOMER_ORGANIZATION_FOR_PRESALES,
  GET_CUSTOMER_PURCHASE_REASON_FOR_PRESALES,
  GET_LEAD_CATEGORY_FOR_PRESALES,
  GET_SUB_SOURCE_FOR_LEAD,
  GET_EMPLOYMENT_TYPE,
  CHECK_EXISTING_LEAD,
  GET_USER_FOR_LEAD_SITE_VISIT,
  GET_SITE_VISIT_VECHICLE_MODE,
  GET_LEAD_CALL_STATUS_FOR_FOLLOW_UP,
  GET_LEAD_STATUS_FOR_FOLLOW_UP,
  GET_LEAD_UNQULIFICATION_REASON_FOR_FOLLOW_UP,
  GET_LEAD_BUDGET_FOR_FOLLOW_UP,
  GET_LEAD_LOCATION_FOR_FOLLOW_UP,
  GET_LEAD_LOCATION_FOR_FOLLOW_UP_AUTO,
  MAKE_EXOTEL_OUTGOING_CALL,
  //lead site visit plan
  GET_SITE_VISIT_PLAN,
  GET_SITE_VISIT_PLAN_EXPORT,
  GET_SITE_VISIT_PLAN_DETAIL,
  GET_SITE_VISIT_PLAN_FILTER_PROJECT,
  GET_SITE_VISIT_PLAN_FILTER_ADDED_BY,
  GET_SITE_VISIT_PLAN_FILTER_STM,
  GET_ASSIGN_TO_USER_FOR_SITE_VISIT,
  GET_IMPORT_LEAD,
  GET_IMPORT_LEAD_FILTER_UPLOADED_BY,
  GET_LEAD_FOR_BULK,
  GET_PROJECT_SHAREABLE_INFO,
  GET_SITE_DETAIL_FOR_PRESALES,
  CLEAR_SITE_DETAIL_FOR_PRESALES,
  GET_PROJECT_INFO,
  GET_PROJECT_INFO_EXPORT,
  GET_PROJECT_INFO_DETAIL,
  GET_CRM_SALES_DOCUMENT_TYPE,
  // externalLead
  GET_EXTERNAL_LEAD,
  GET_EXTERNAL_LEAD_EXPORT,
  GET_EXTERNAL_LEAD_FILTER_PROJECT,
  GET_EXTERNAL_LEAD_FILTER_SOURCE,
  GET_EXTERNAL_LEAD_FILTER_SUB_SOURCE,
  GET_EXTERNAL_LEAD_FILTER_ASSIGNED_TO,
  GET_EXTERNAL_LEAD_FILTER_LEAD_STATUS,
  // calllog
  GET_LEAD_CALL_LOG,
  GET_LEAD_CALL_LOG_EXPORT,
  GET_LEAD_CALL_LOG_FILTER_PROJECT,
  GET_LEAD_CALL_LOG_FILTER_CALL_TYPE,
  GET_LEAD_CALL_LOG_FILTER_RECEIVER,
  GET_LEAD_CALL_LOG_FILTER_CALL_STATUS,
  // callReport
  GET_CALL_SUMMARY,
  GET_CALL_SUMMARY_EXPORT,
  GET_CALL_SUMMARY_FILTER_DEPARTMENT,
  GET_CALL_SUMMARY_FILTER_USER,
  // callblock
  GET_BLOCKED_NUMBER,
  GET_BLOCKED_NUMBER_EXPORT,
  GET_BLOCKED_NUMBER_FILTER_USER,
  GET_BLOCKED_NUMBER_FILTER_STATUS,
  GET_BLOCKED_NUMBER_DETAIL,
  GET_USER_AVAILABILITY,
  // bulklead
  GET_BULK_LEAD_TRANSFER,
  GET_BULK_LEAD_TRANSFER_EXPORT,
  GET_BULK_LEAD_TRANSFER_FILTER_USER,
  GET_BULK_LEAD_TRANSFER_FILTER_STATUS,
  GET_LEAD_FOR_BULK_TRANSFER,
  GET_LEAD_FILTER_SOURCE_CATEGORY,
  GET_LEAD_FILTER_SUB_SOURCE,
  GET_LEAD_FILTER_REASON,
  GET_LEAD_FILTER_SUB_REASON,
  GET_BULK_LEAD_TRANSFER_DETAIL,
  GET_BULK_LEAD_TRANSFER_ITEM,
} from "./types";

const initialState = {
  // Presales Incentive Plan
  getPresalesIncentivePlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getPresalesIncentivePlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getPresalesIncentivePlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getItemForPreSalesIncentive: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  //PreSales New
  getLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadSearch: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadForBulk: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getUserForLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getUserForSiteVisitHandled: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCountryCodeForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getProjectForLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSourceCategoryForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSourceForLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSubSourceForLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCategoryForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCrmLeadStatusCount: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallContactNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterDateType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadOwnerFilterList: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadSiteVisitExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadProfile: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCity: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerCurrentLivingForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerSuitableTimeForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerConstructionPlanningForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerBudgetForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCrmDimensionForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerIncomeForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerWorkExperienceForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerWorkFunctionForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerWorkSectorForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerOrganizationForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getEmploymentType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCustomerPurchaseReasonForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  checkExistingLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getUserForLeadSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteVisitVehicleMode: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallStatusForFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadStatusForFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadUnqualificationReasonForFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadBudgetForFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadLocationForFollowUp: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadLocationForFollowUpAuto: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  makeExotelOutgoingCall: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  //lead site visit plan
  getSiteVisitPlan: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteVisitPlanExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteVisitPlanDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteVisitPlanFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadSiteVisitFilterAddedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteVisitPlanFilterStm: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getAssingToUserForSiteVisit: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getImportedLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getImportedLeadFilterUploadedBy: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  getProjectShareableInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getSiteDetailForPreSales: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getProjectInfo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getProjectInfoExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getProjectInfoDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCrmSalesDocumentType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  // externalLead
  getExternalLead: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getExternalLeadExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getExternalLeadFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getExternalLeadFilterSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getExternalLeadFilterSubSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getExternalLeadFilterAssignedTo: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getExternalLeadFilterLeadStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  // calllog
  getLeadCallLog: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallLogExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallLogFilterProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallLogFilterCallType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallLogFilterReceiver: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadCallLogFilterCallStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  // callReport
  getCallSummary: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCallSummaryExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCallSummaryFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getCallSummaryFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  // callblock
  getBlockedNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBlockedNumberExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBlockedNumberFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBlockedNumberFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBlockedNumberDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getUserAvailability: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },

  // bulklead
  getBulkLeadTransfer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBulkLeadTransferExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBulkLeadTransferFilterUser: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBulkLeadTransferFilterStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadForBulkTransfer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterSourceCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterSubSource: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getLeadFilterSubReason: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBulkLeadTransferDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
  getBulkLeadTransferItem: {
    error: false,
    message: "",
    data: [],
    totalCount: 0,
  },
};
const Sales_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Presales Incentive Plan
    case GET_PRESALES_INCENTIVE_PLAN:
      return Object.assign({}, state, {
        getPresalesIncentivePlan: payload,
      });
    case GET_PRESALES_INCENTIVE_PLAN_EXPORT:
      return Object.assign({}, state, {
        getPresalesIncentivePlanExport: payload,
      });
    case GET_PRESALES_INCENTIVE_PLAN_DETAIL:
      return Object.assign({}, state, {
        getPresalesIncentivePlanDetail: payload,
      });
    case GET_ITEM_FOR_PRE_SALES_INCENTIVE:
      return Object.assign({}, state, {
        getItemForPreSalesIncentive: payload,
      });

    // PreSales New
    case GET_LEAD:
      return Object.assign({}, state, { getLead: payload });
    case GET_LEAD_EXPORT:
      return Object.assign({}, state, { getLeadExport: payload });
    case GET_LEAD_SEARCH:
      return Object.assign({}, state, { getLeadSearch: payload });
    case GET_LEAD_FOR_BULK:
      return Object.assign({}, state, { getLeadForBulk: payload });
    case GET_LEAD_DETAIL:
      return Object.assign({}, state, { getLeadDetail: payload });
    case GET_USER_FOR_LEAD:
      return Object.assign({}, state, { getUserForLead: payload });
    case GET_USER_FOR_SITE_VISIT_HANDLED:
      return Object.assign({}, state, { getUserForSiteVisitHandled: payload });
    case GET_COUNTRY_CODE_FOR_PRESALES:
      return Object.assign({}, state, { getCountryCodeForPreSales: payload });
    case GET_PROJECT_FOR_LEAD:
      return Object.assign({}, state, { getProjectForLead: payload });
    case GET_SOURCE_CATEGORY_FOR_PRESALES:
      return Object.assign({}, state, {
        getSourceCategoryForPreSales: payload,
      });
    case GET_SUB_SOURCE_FOR_LEAD:
      return Object.assign({}, state, { getSubSourceForLead: payload });
    case GET_SOURCE_FOR_LEAD:
      return Object.assign({}, state, { getSourceForLead: payload });
    case GET_LEAD_CATEGORY_FOR_PRESALES:
      return Object.assign({}, state, { getLeadCategoryForPreSales: payload });
    case GET_CRM_LEAD_STATUS_COUNT:
      return Object.assign({}, state, { getCrmLeadStatusCount: payload });
    case GET_LEAD_CALL_CONTACT_NUMBER:
      return Object.assign({}, state, { getLeadCallContactNumber: payload });
    case GET_LEAD_FILTER_PROJECT:
      return Object.assign({}, state, { getLeadFilterProject: payload });
    case GET_LEAD_FILTER_SOURCE:
      return Object.assign({}, state, { getLeadFilterSource: payload });
    case GET_LEAD_FILTER_STATUS:
      return Object.assign({}, state, { getLeadFilterStatus: payload });
    case GET_LEAD_FILTER_CATEGORY:
      return Object.assign({}, state, { getLeadFilterCategory: payload });
    case GET_LEAD_FILTER_DEPARTMENT:
      return Object.assign({}, state, { getLeadFilterDepartment: payload });
    case GET_LEAD_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, { getLeadFilterAssignedTo: payload });
    case GET_LEAD_FILTER_DATE_TYPE:
      return Object.assign({}, state, { getLeadFilterDateType: payload });
    case GET_LEAD_OWNER_FILTER_LIST:
      return Object.assign({}, state, { getLeadOwnerFilterList: payload });
    case GET_LEAD_SITE_VISIT:
      return Object.assign({}, state, { getLeadSiteVisit: payload });
    case GET_LEAD_SITE_VISIT_EXPORT:
      return Object.assign({}, state, {
        getLeadSiteVisitExport: payload,
      });
    case GET_LEAD_PROFILE:
      return Object.assign({}, state, { getLeadProfile: payload });
    case GET_CITY:
      return Object.assign({}, state, { getCity: payload });
    case GET_CUSTOMER_CURRENT_LIVING_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerCurrentLivingForPreSales: payload,
      });
    case GET_CUSTOMER_SUITABLE_TIME_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerSuitableTimeForPreSales: payload,
      });
    case GET_CUSTOMER_CONSTRUCTION_PLANNING_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerConstructionPlanningForPreSales: payload,
      });
    case GET_CUSTOMER_BUDGET_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerBudgetForPreSales: payload,
      });
    case GET_CRM_DIMENSION_FOR_PRESALES:
      return Object.assign({}, state, { getCrmDimensionForPreSales: payload });
    case GET_CUSTOMER_INCOME_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerIncomeForPreSales: payload,
      });
    case GET_CUSTOMER_WORK_EXPERIENCE_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerWorkExperienceForPreSales: payload,
      });
    case GET_CUSTOMER_WORK_FUNCTION_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerWorkFunctionForPreSales: payload,
      });
    case GET_CUSTOMER_WORK_SECTOR_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerWorkSectorForPreSales: payload,
      });
    case GET_CUSTOMER_ORGANIZATION_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerOrganizationForPreSales: payload,
      });
    case GET_EMPLOYMENT_TYPE:
      return Object.assign({}, state, { getEmploymentType: payload });

    case GET_CUSTOMER_PURCHASE_REASON_FOR_PRESALES:
      return Object.assign({}, state, {
        getCustomerPurchaseReasonForPreSales: payload,
      });
    case CHECK_EXISTING_LEAD:
      return Object.assign({}, state, {
        checkExistingLead: payload,
      });
    case GET_USER_FOR_LEAD_SITE_VISIT:
      return Object.assign({}, state, {
        getUserForLeadSiteVisit: payload,
      });
    case GET_SITE_VISIT_VECHICLE_MODE:
      return Object.assign({}, state, {
        getSiteVisitVehicleMode: payload,
      });
    case GET_LEAD_CALL_STATUS_FOR_FOLLOW_UP:
      return Object.assign({}, state, {
        getLeadCallStatusForFollowUp: payload,
      });
    case GET_LEAD_STATUS_FOR_FOLLOW_UP:
      return Object.assign({}, state, {
        getLeadStatusForFollowUp: payload,
      });
    case GET_LEAD_UNQULIFICATION_REASON_FOR_FOLLOW_UP:
      return Object.assign({}, state, {
        getLeadUnqualificationReasonForFollowUp: payload,
      });
    case GET_LEAD_BUDGET_FOR_FOLLOW_UP:
      return Object.assign({}, state, {
        getLeadBudgetForFollowUp: payload,
      });
    case GET_LEAD_LOCATION_FOR_FOLLOW_UP:
      return Object.assign({}, state, {
        getLeadLocationForFollowUp: payload,
      });
    case GET_LEAD_LOCATION_FOR_FOLLOW_UP_AUTO:
      return Object.assign({}, state, {
        getLeadLocationForFollowUpAuto: payload,
      });
    case MAKE_EXOTEL_OUTGOING_CALL:
      return Object.assign({}, state, {
        makeExotelOutgoingCall: payload,
      });
    //lead site visit plan

    case GET_SITE_VISIT_PLAN:
      return Object.assign({}, state, { getSiteVisitPlan: payload });

    case GET_SITE_VISIT_PLAN_EXPORT:
      return Object.assign({}, state, { getSiteVisitPlanExport: payload });

    case GET_SITE_VISIT_PLAN_DETAIL:
      return Object.assign({}, state, { getSiteVisitPlanDetail: payload });

    case GET_SITE_VISIT_PLAN_FILTER_PROJECT:
      return Object.assign({}, state, {
        getSiteVisitPlanFilterProject: payload,
      });
    case GET_SITE_VISIT_PLAN_FILTER_ADDED_BY:
      return Object.assign({}, state, {
        getLeadSiteVisitFilterAddedBy: payload,
      });
    case GET_SITE_VISIT_PLAN_FILTER_STM:
      return Object.assign({}, state, { getSiteVisitPlanFilterStm: payload });

    case GET_ASSIGN_TO_USER_FOR_SITE_VISIT:
      return Object.assign({}, state, { getAssingToUserForSiteVisit: payload });

    case GET_IMPORT_LEAD:
      return Object.assign({}, state, { getImportedLead: payload });

    case GET_IMPORT_LEAD_FILTER_UPLOADED_BY:
      return Object.assign({}, state, {
        getImportedLeadFilterUploadedBy: payload,
      });
    case GET_PROJECT_SHAREABLE_INFO:
      return Object.assign({}, state, {
        getProjectShareableInfo: payload,
      });
    case GET_SITE_DETAIL_FOR_PRESALES:
      return Object.assign({}, state, {
        getSiteDetailForPreSales: payload,
      });
    case CLEAR_SITE_DETAIL_FOR_PRESALES:
      return Object.assign({}, state, {
        getSiteDetailForPreSales: payload,
      });
    // project info
    case GET_PROJECT_INFO:
      return Object.assign({}, state, {
        getProjectInfo: payload,
      });
    case GET_PROJECT_INFO_EXPORT:
      return Object.assign({}, state, {
        getProjectInfoExport: payload,
      });
    case GET_PROJECT_INFO_DETAIL:
      return Object.assign({}, state, {
        getProjectInfoDetail: payload,
      });
    case GET_CRM_SALES_DOCUMENT_TYPE:
      return Object.assign({}, state, {
        getCrmSalesDocumentType: payload,
      });
    // externalLead
    case GET_EXTERNAL_LEAD:
      return Object.assign({}, state, {
        getExternalLead: payload,
      });
    case GET_EXTERNAL_LEAD_EXPORT:
      return Object.assign({}, state, {
        getExternalLeadExport: payload,
      });
    case GET_EXTERNAL_LEAD_FILTER_PROJECT:
      return Object.assign({}, state, {
        getExternalLeadFilterProject: payload,
      });
    case GET_EXTERNAL_LEAD_FILTER_SOURCE:
      return Object.assign({}, state, {
        getExternalLeadFilterSource: payload,
      });
    case GET_EXTERNAL_LEAD_FILTER_SUB_SOURCE:
      return Object.assign({}, state, {
        getExternalLeadFilterSubSource: payload,
      });
    case GET_EXTERNAL_LEAD_FILTER_ASSIGNED_TO:
      return Object.assign({}, state, {
        getExternalLeadFilterAssignedTo: payload,
      });
    case GET_EXTERNAL_LEAD_FILTER_LEAD_STATUS:
      return Object.assign({}, state, {
        getExternalLeadFilterLeadStatus: payload,
      });
    // calllog
    case GET_LEAD_CALL_LOG:
      return Object.assign({}, state, {
        getLeadCallLog: payload,
      });
    case GET_LEAD_CALL_LOG_EXPORT:
      return Object.assign({}, state, {
        getLeadCallLogExport: payload,
      });
    case GET_LEAD_CALL_LOG_FILTER_PROJECT:
      return Object.assign({}, state, {
        getLeadCallLogFilterProject: payload,
      });
    case GET_LEAD_CALL_LOG_FILTER_CALL_TYPE:
      return Object.assign({}, state, {
        getLeadCallLogFilterCallType: payload,
      });
    case GET_LEAD_CALL_LOG_FILTER_RECEIVER:
      return Object.assign({}, state, {
        getLeadCallLogFilterReceiver: payload,
      });
    case GET_LEAD_CALL_LOG_FILTER_CALL_STATUS:
      return Object.assign({}, state, {
        getLeadCallLogFilterCallStatus: payload,
      });
    // callReport
    case GET_CALL_SUMMARY:
      return Object.assign({}, state, {
        getCallSummary: payload,
      });
    case GET_CALL_SUMMARY_EXPORT:
      return Object.assign({}, state, {
        getCallSummaryExport: payload,
      });
    case GET_CALL_SUMMARY_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getCallSummaryFilterDepartment: payload,
      });
    case GET_CALL_SUMMARY_FILTER_USER:
      return Object.assign({}, state, {
        getCallSummaryFilterUser: payload,
      });
    // callblock
    case GET_BLOCKED_NUMBER:
      return Object.assign({}, state, {
        getBlockedNumber: payload,
      });
    case GET_BLOCKED_NUMBER_EXPORT:
      return Object.assign({}, state, {
        getBlockedNumberExport: payload,
      });
    case GET_BLOCKED_NUMBER_FILTER_USER:
      return Object.assign({}, state, {
        getBlockedNumberFilterUser: payload,
      });
    case GET_BLOCKED_NUMBER_FILTER_STATUS:
      return Object.assign({}, state, {
        getBlockedNumberFilterStatus: payload,
      });
    case GET_BLOCKED_NUMBER_DETAIL:
      return Object.assign({}, state, {
        getBlockedNumberDetail: payload,
      });
    case GET_USER_AVAILABILITY:
      return Object.assign({}, state, {
        getUserAvailability: payload,
      });
    // bulklead
    case GET_BULK_LEAD_TRANSFER:
      return Object.assign({}, state, {
        getBulkLeadTransfer: payload,
      });
    case GET_BULK_LEAD_TRANSFER_EXPORT:
      return Object.assign({}, state, {
        getBulkLeadTransferExport: payload,
      });
    case GET_BULK_LEAD_TRANSFER_FILTER_USER:
      return Object.assign({}, state, {
        getBulkLeadTransferFilterUser: payload,
      });
    case GET_BULK_LEAD_TRANSFER_FILTER_STATUS:
      return Object.assign({}, state, {
        getBulkLeadTransferFilterStatus: payload,
      });
    case GET_LEAD_FOR_BULK_TRANSFER:
      return Object.assign({}, state, {
        getLeadForBulkTransfer: payload,
      });
    case GET_LEAD_FILTER_SOURCE_CATEGORY:
      return Object.assign({}, state, {
        getLeadFilterSourceCategory: payload,
      });
    case GET_LEAD_FILTER_SUB_SOURCE:
      return Object.assign({}, state, {
        getLeadFilterSubSource: payload,
      });
    case GET_LEAD_FILTER_REASON:
      return Object.assign({}, state, {
        getLeadFilterReason: payload,
      });
    case GET_LEAD_FILTER_SUB_REASON:
      return Object.assign({}, state, {
        getLeadFilterSubReason: payload,
      });
    case GET_BULK_LEAD_TRANSFER_DETAIL:
      return Object.assign({}, state, {
        getBulkLeadTransferDetail: payload,
      });
    case GET_BULK_LEAD_TRANSFER_ITEM:
      return Object.assign({}, state, {
        getBulkLeadTransferItem: payload,
      });
    default:
      return state;
  }
};
export default Sales_reducer;
